import React from 'react'
import Header from '../components/Header.jsx';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import ProjectItem from '../components/ProjectItem.jsx';
import Grid from '@mui/material/Grid';


export const Projects = () => {
    return (
        <div className="about-me">
            <Header />
            <Container maxWidth="lg">
                <Box sx={{ py: { xs: 3, md: 5 }, minHeight: '100vh' }}>
                    <h2 style={{ marginTop: 0, color: '#0f172a' }}>Projects</h2>
                    <Box>
                        <Grid container spacing={2.5}>
                            <Grid item xs={12} sm={6} md={4}>
                                <ProjectItem />
                            </Grid>
                            {/* <Grid item xs={4}>
                                <ProjectItem />
                            </Grid>
                            <Grid item xs={4}>
                                <ProjectItem />
                            </Grid>
                            <Grid item xs={4}>
                                <ProjectItem />
                            </Grid>
                            <Grid item xs={4}>
                                <ProjectItem />
                            </Grid>
                            <Grid item xs={4}>
                                <ProjectItem />
                            </Grid> */}
                        </Grid>

                    </Box>
                    <div>
                    </div>
                </Box>
            </Container>
        </div>
    )
}

export default Projects
